/*
 * @描述:
 * @作者: lidong
 * @时间: Do not edit
 * @最后更新时间: Do not edit
 * @更新: lidong
 * @参考:
 */
const modal = {
  mainImageChange: false, //主图是否变更
  detailImageChange: false, //详情图是否变更
  goodsId: '', // 供应商商品id
  regionData: [], // 地区信息
  cityData: [], //城市信息
  updtateTag: false, //因为redux更新不是深拷贝，用来作为更新标识使用
  auditAllStatus: 0, // 是否审核及上架
  auditStatus: 0, // 审核状态
  auditStatusStr: '', // 审核状态中文类型
  city: '4521985', // 城市
  cityStr: '', // 城市编码
  supAllList: [], // 供应商配送模板集合
  comparisonMap: {
    // 比价信息集合
    JD: {
      createBy: '', // 创建人
      createTime: '2021-01-04T06:30:55.609Z', // 创建人
      id: 0, // 竞价id
      platformCount: '', // 平台商品销量
      platformName: '', // 平台名称
      platformPrice: '', // 平台价格
      platformType: '', // 平台类型 JD=京东 ，TM=淘宝天猫，PDD=拼多多
      productId: 0, // 商品id
      updateBy: '', // 更新人
      updateTime: '', // 更新时间
    },
    TM: {
      createBy: '', // 创建人
      createTime: '', // 创建人
      id: 0, // 竞价id
      platformCount: '', // 平台商品销量
      platformName: '', // 平台名称
      platformPrice: '', // 平台价格
      platformType: '', // 平台类型 JD=京东 ，TM=淘宝天猫，PDD=拼多多
      productId: 0, // 商品id
      updateBy: '', // 更新人
      updateTime: '', // 更新时间
    },
  },
  currentQty: 0, // 可用库存
  id: '', // 接口返回商品id
  imageMap: {
    // 商品图片集合
    main: [
      {
        id: 0, // 图片id
        image: '', // 图片地址
        imageHeight: 0, // 图片高
        imageSize: 0, // 图片大小
        imageType: '', // 图片类型：main：主图，small：分类小图，middle：首页中图，detail：商品详情图
        imageWidth: 0, // 图片宽
        productCode: '', // 商品编码
        sequence: 0, // 图片序号
        supplierCode: '', // 供应商编码
      },
    ],
    small: [],
    detail: [],
  },
  imageUrl: '', // 缩略图id
  logisticsCode: '', // 物流公司
  orderQty: 0, // 预占库存
  prodectCode: '', // 商品编码
  prodectName: '', // 商品名称
  productBarCode: '', //
  productStatus: 0, // 商品状态码
  productStatusStr: '', // 商品状态
  province: '', // 省份
  remark: '', // 审核备注
  sendGoodsCycle: 0, // 补货周期
  specs: '', // 规格
  supplierCode: '', // 供应商编码
  unit: '', // 单位
  usableQty: 0, // 现货库存
  goodsDetailImg: [], //详情图数据
  imgData: [], ////主图数据
  productCode: '',
  editType: null, // 编辑类型 1基本信息 2链接 3图片
  productBenchmarkingHeadResList: [
    { benchmarkingBbject: null, connectionCombinationWay: null, productBenchmarkingInfoList: [] },
  ],
  benchmarkingBbjectValue: null, // 对标对象
  connectionCombinationWayValue: null, // 组合方式
};

export default modal;
